// removed by extract-text-webpack-plugin
module.exports = {"xAxisItemContainer":"_1hPP","xAxisTick":"_3S5T"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/LandingPage/Chart/XAxis/XAxisTick/styles.scss
// module id = 444
// module chunks = 0